import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`v1/api/perm/mapping-roles?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`v1/api/perm/mapping-roles/${id}`, { params });
}

export async function create(body) {
  return request(`v1/api/perm/mapping-roles`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`v1/api/perm/mapping-roles/${id}`, {
    method: 'POST',
    body,
  });
}

export async function deleteRecord(payload){
  console.log(payload)
  return request(`v1/api/perm/mapping-roles/role/${payload.role_id}/user/${payload.user_id}/partner/${payload.partner_id}`, {
    method: 'DELETE',
  });
}